<template>
  <div class="home">

    <p>
      https://medium.com/@vivekdhumal/how-to-make-a-video-recorder-using-videojs-record-vue-and-laravel-c586fed455bd
    </p>
    <v-row justify="center">
      <v-col cols="12">
        <v-alert
            type="error"
            color="red"
            v-if="error"
        >{{ error }}
        </v-alert>

        <VideoRecorder
            ref="videorecorder"
            v-on:isRecording="changeRecording"
            v-on:onFinisedRecording="onFinisedRecording"
            @onError="onError"
        />

      </v-col>

      <v-col cols="12">
        <v-btn small @click="startCountdown" :disabled="isRecording" class="ma-2 btnStart">Start</v-btn>
        <v-btn small @click="recordVideoStop" :disabled="!isRecording" class="ma-2 btnStop">Stop</v-btn>
        <v-btn small @click="$refs.videorecorder.enumerateDevices()" class="ma-2 btnEnumerateDevices">enumerateDevices</v-btn>
        <v-btn small @click="$refs.videorecorder.resetPlayer()" class="ma-2 btnReset">RESET</v-btn>
        <v-btn small @click="$refs.videorecorder.playVideo()" :disabled="!videoRecorded" class="ma-2 btnPlay">Play</v-btn>
        <v-btn small @click="uploadVideo" :disabled="!videoRecorded" class="ma- btnUploadFile">Upload File</v-btn>
      </v-col>


    </v-row>

    <v-row :disabled="!videoRecorded">
      <v-col>
        <v-progress-linear

            v-model="uploadPercentage"
            color="grey accent-4"
        ></v-progress-linear>
        <div>Uploading: {{ uploadPercentage }} %</div>

<!--        <div v-if="recordedVideoFile">-->
<!--{{recordedVideoFile.lastModified}}-->
<!--        </div>-->
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import VideoRecorder from "../components/recorder/VideoRecorder";
import { mapState } from 'vuex';

export default {
  name: 'recorder',
  components: {
    VideoRecorder,
  },
  data: () => ({
    error: null,
    isRecording: false,
    videoRecorded: false,
    recordedVideo: null,
    uploadPercentage: 0,
  }),
  // ...
  computed: {
    ...mapState({
      recordedVideoFile: state => state.recordedVideo
    })
  },
  methods: {

    startCountdown() {
      this.$refs.videorecorder.startCountdown();
    },

    changeRecording(args) {
      this.isRecording = args;
    },
    onError(args) {
      console.log('on Record ERROR', args);
      this.videoRecorded = false;
      this.recordedVideo = null;
      this.error = args;
    },
    onFinisedRecording(args) {
      console.log('on Record FINISHED', args);
      this.videoRecorded = true;
      this.recordedVideo = args;
      this.$store.commit('setVideoFile', args);
    },
    resetTimer() {
      console.log('Page Timer Reset');
      clearTimeout(this.pageTimer);
      this.startTimer();
    },

    recordVideoStop() {
      this.$refs.videorecorder.stopRecording();
    },

    uploadVideo() {
      var self = this;

      //this.player.record().saveAs({'video': 'my-video'});
      //https://github.com/collab-project/videojs-record/blob/master/examples/upload/fine-uploader.html
      //https://github.com/collab-project/videojs-record/blob/master/examples/upload/jquery.fileupload.html
      var videoFile = this.recordedVideoFile;
      console.log('finished recording: ', videoFile);
      // upload data to server
      // var filesList = [videoFile];
      let formData = new FormData();
      //formData.append('filesList', filesList);
      formData.append('data', JSON.stringify(this.currentDataset));
      formData.append('sequenceId', this.sequenceId);
      formData.append('videoFile', videoFile);

      /*
        Make the request to the POST /select-files URL
      */
      this.isUploading = true;
      this.$http.post('/wko-video-booth/upload/index.php',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (e) => {
              console.log(e);
              if (e.lengthComputable) {
                console.log(e.loaded / e.total * 100);
                self.uploadPercentage = (e.loaded / e.total * 100).toFixed(2);
              }
            }
          })
          .then(function () {
            console.log('SUCCESS!!');
            self.isUploading = false;
            self.gotoStartPage();
          })
          .catch(function (e) {
            console.log('FAILURE!! ' + e);
          });
    }

  }
}
</script>
